import styles from './EditProjectPerformersModal.module.css';

import addIcon from 'assets/svg/add-01.svg';
import iconDelete from 'assets/svg/delete-01.svg';

import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { projectsStore } from '../../../../../store/mobx/projects.store';
import RegularButton from 'ui/RegularButton';
import IconButton from 'ui/IconButton';
import Tooltip from 'ui/Tooltip/index';
import Modal from 'ui/Modal';
import { getAllGroupsWithUsers } from 'services/user.services';
import Icon from 'ui/Icon';
import Select from 'ui/Select';
import { address_server_short } from '../../../../../config';
import useAlert from 'hooks/useAlert';
import { USER_GROUPS } from '../../../../../consts/user.consts';

const EditProjectPerformersModal = observer(({ setModalOpened }) => {
  const { showAlert } = useAlert();
  const { selectedProject, upsertProjectPerformer, removeProjectPerformer } = projectsStore;
  const [allUsers, setAllUsers] = useState([]);
  const [selectedPerformerId, setSelectedPerformerId] = useState(null);
  const [projectPerformers, setProjectPerformers] = useState([]);

  useEffect(() => {
    loadAllUsers();
  }, [selectedProject]);

  useEffect(() => {
    if (!selectedProject?.users) return;
    setProjectPerformers(selectedProject?.users);
  }, [selectedProject?.users]);

  const loadAllUsers = async () => {
    const result = await getAllGroupsWithUsers();
    if (!result) return;
    const filteredGroups = result?.groups?.filter(
      (group) => group?.id !== USER_GROUPS.ADMINISTRATOR,
    );
    const usersInGroups = filteredGroups?.flatMap((item) => item?.users);
    setAllUsers(usersInGroups);
  };

  const closeModal = () => setModalOpened(false);

  const handleAddPerformer = async () => {
    if (selectedPerformerId) {
      const result = await upsertProjectPerformer(selectedProject.id, selectedPerformerId);
      if (!result.success) errorAddedPerformerAlert(result.error_code, result.error);
      setSelectedPerformerId(null);
    }
  };

  const handleDeletePerformer = async (performerID) => {
    await removeProjectPerformer(selectedProject.id, performerID);
  };

  const handleChangeSelect = (id) => {
    setSelectedPerformerId(id);
  };

  const errorAddedPerformerAlert = (code, message) => {
    showAlert(` Код № ${code}${message ? ` - ${message}` : ''}!`, 'error');
  };

  const Performer = ({ key, performer }) => (
    <>
      <div className={styles.performerWrapper} key={key}>
        <div className={styles.performerInfo}>
          <div className={styles.imageWrapper}>
            <img className={styles.image} src={address_server_short + performer.avatar} />
          </div>
          <div>
            <div className={styles.performerTitle}>{performer.fio}</div>
            <div className={styles.performerSubtitle}>{performer.position}</div>
          </div>
        </div>
        <Tooltip text="Удалить">
          <IconButton
            onClick={() => handleDeletePerformer(performer.id)}
            icon={iconDelete}
            size="20"
            color="primary"
          />
        </Tooltip>
      </div>
      <div className={styles.divider} />
    </>
  );

  return (
    <Modal hideDefaultFooter={true} title="Редактирование исполнителей" onClose={closeModal}>
      <div className={styles.selectionWrapper}>
        <Select
          options={allUsers}
          value={selectedPerformerId}
          onChange={handleChangeSelect}
          titleKey="fio"
          valueKey="id"
          className={styles.select}
          notSelectedText="Не выбрано"
          clearable={false}
          hideErrorBlock
          renderOption={({ option }) => (
            <div className={styles.wrapperTitleSelect}>
              <span className={styles.titleSelect}>{option.fio}</span>
              <span>{option.position}</span>
            </div>
          )}
        />
        <RegularButton
          onClick={handleAddPerformer}
          appendIcon={<Icon color={'#ffffff'} src={addIcon} width={'12px'} height={'12px'} />}
          className={styles.button}
          color="primary"
          variant="flat"
          text="Добавить"
          disabled={!selectedPerformerId}
        />
      </div>
      <div className={styles.container}>
        {(projectPerformers?.length &&
          projectPerformers?.map((performer) => (
            <Performer key={performer.id} performer={performer} />
          ))) || <div className={styles.notPerformer}>Исполнители не добавлены</div>}
      </div>
    </Modal>
  );
});

export default EditProjectPerformersModal;
